import CarsSearchFormWithContainer from './component/CarsSearchFormContainer';
// eslint-disable-next-line import/no-named-as-default
import CarsSearchForm from './component/CarsSearchForm';
import reducer from './redux/suggest/reducer';
import * as actions from './redux/suggest/actions';
import getQueryFromLocation from './utilities/getQueryFromLocation';
import selectRegisteredFields from './redux/suggest/selectors';
import * as CONSTANTS from './consts';
import withCarSearchInitialValues from './withCarSearchInitialValues';

const utilities = {
  getQueryFromLocation,
  selectRegisteredFields,
};

export {
  CarsSearchFormWithContainer,
  CarsSearchForm,
  CONSTANTS,
  reducer,
  actions,
  utilities,
  withCarSearchInitialValues,
};
